if (!customElements.get("card-slider")) {
  class CardSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const swiperOptions = JSON.parse(this.getAttribute("data-swiper-options")) || {};

      window.addEventListener("shopify:section:load", () => {
        this.reInitSlider(swiperOptions);
      });

      setTimeout(() => {
        if (!this.slider) {
          this.initSlider(swiperOptions);
        }
      }, 0);

      if (this.classList.contains("js-testimonials")) {
        let lastIsMobile = window.innerWidth < (typeof mobileWidth !== "undefined" ? mobileWidth : 750);
        const initOrUpdateSlider = () => {
          const isMobile = window.innerWidth < (typeof mobileWidth !== "undefined" ? mobileWidth : 750);
          if (isMobile !== lastIsMobile) {
            lastIsMobile = isMobile;
            this.reInitSlider(swiperOptions);
          }
        };

        window.addEventListener("resize", initOrUpdateSlider);
      }

      window.addEventListener("resize", () => {
        const mw = typeof mobileWidth !== "undefined" ? mobileWidth : 750;
        if (swiperOptions.disabledOnMobile && window.innerWidth < mw) {
          if (this.slider) {
            this.slider.destroy();
            this.slider = null;
          }
        } else if (!this.slider) {
          this.initSlider(swiperOptions);
        }
      });
    }

    reInitSlider(swiperOptions) {
      if (this.slider) {
        this.slider.destroy();
        this.slider = null;
      }
      this.initSlider(swiperOptions);
    }

    initSlider(swiperOptions) {
      const progressCircle = document.querySelector(`.autoplay-progress--${swiperOptions.sectionId} svg`);
      const progressContent = document.querySelector(`.autoplay-progress--${swiperOptions.sectionId} span`);
      const mw = typeof mobileWidth !== "undefined" ? mobileWidth : 750;

      if (swiperOptions.disabledOnMobile && window.innerWidth < mw) return;

      if (swiperOptions.pagination == "render_bullet") {
        swiperOptions.pagination = {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet: (i, className) => `<button class="${className}"><span>${i + 1}</span></button>`
        };
      } else if (swiperOptions.pagination == "progressbar") {
        swiperOptions.pagination = {
          el: ".swiper-pagination",
          type: "progressbar"
        };
      } else if (swiperOptions.pagination == "bullets") {
        swiperOptions.pagination = {
          el: ".swiper-pagination",
          clickable: true
        };
      } else {
        swiperOptions.pagination = false;
      }

      if (swiperOptions.rewind) {
        swiperOptions.loop = false;
      }
      if (swiperOptions.loop && swiperOptions.slideCount < 2) {
        swiperOptions.loop = false;
      }

      let prevButton = this.querySelector('[class*="swiper-button--prev"]') 
        || (swiperOptions.sectionId ? document.querySelector(`.swiper-button--prev-${swiperOptions.sectionId}`) : null)
        || document.querySelector('.swiper-button--prev');

      let nextButton = this.querySelector('[class*="swiper-button--next"]') 
        || (swiperOptions.sectionId ? document.querySelector(`.swiper-button--next-${swiperOptions.sectionId}`) : null)
        || document.querySelector('.swiper-button--next');

      const navigationOption = (swiperOptions.navigation === false) ? false : {
        nextEl: nextButton || ".swiper-button--next",
        prevEl: prevButton || ".swiper-button--prev"
      };

      let sliderOptions = {
        slidesPerView: swiperOptions.slidesPerView || 1.1,
        spaceBetween: swiperOptions.spaceBetweenMobile ?? 16,
        resistanceRatio: 0.72,
        navigation: navigationOption,
        breakpoints: {
          480: {
            slidesPerView: "auto",
            spaceBetween: swiperOptions.spaceBetweenMobile || 2
          },
          750: {
            slidesPerView: swiperOptions.slidesPerViewDesktop || 3,
            spaceBetween: swiperOptions.spaceBetweenDesktop ?? 16
          }
        }
      };

      if (this.classList.contains("horizontal-w-media")) {
        sliderOptions = {
          slidesPerView: swiperOptions.slidesPerView || 1.1,
          rewind: swiperOptions.rewind || false,
          followFinger: swiperOptions.followFinger || false,
          spaceBetween: swiperOptions.spaceBetweenMobile || 16,
          pagination: swiperOptions.pagination || false,
          navigation: navigationOption,
          loop: swiperOptions.loop || false,
          autoplay: swiperOptions.autoplay || false,
          breakpoints: {
            750: {
              slidesPerView: 2.2,
              spaceBetween: swiperOptions.spaceBetweenDesktop || 16
            },
            990: {
              slidesPerView: 1
            }
          },
          on: {
            autoplayTimeLeft(_s, time, progress) {
              progressCircle?.style.setProperty("--progress", 1 - progress);
              if (progressContent) progressContent.textContent = `${Math.ceil(time / 1000)}s`;
            }
          }
        };
      }

      if (this.classList.contains("vertical-w-media") && window.innerWidth > 750) {
        sliderOptions = {
          slidesPerView: swiperOptions.slidesPerView || 1.1,
          rewind: swiperOptions.rewind || false,
          followFinger: swiperOptions.followFinger || false,
          spaceBetween: swiperOptions.spaceBetweenMobile || 16,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
            renderBullet: (i, className) => `<button class="${className}"><span>${i + 1}</span></button>`
          },
          navigation: navigationOption,
          loop: swiperOptions.loop || false,
          autoplay: swiperOptions.autoplay || false,
          breakpoints: {
            750: {
              slidesPerView: 2.2,
              spaceBetween: swiperOptions.spaceBetweenDesktop || 16
            },
            990: {
              slidesPerView: 1,
              grid: { rows: 3 }
            }
          }
        };
      }

      if (this.classList.contains("carousel-none-media")) {
        sliderOptions = {
          slidesPerView: swiperOptions.slidesPerView || 1.1,
          rewind: swiperOptions.rewind || false,
          followFinger: swiperOptions.followFinger || false,
          spaceBetween: swiperOptions.spaceBetweenMobile || 16,
          pagination: swiperOptions.pagination || false,
          navigation: navigationOption,
          loop: swiperOptions.loop || false,
          autoplay: swiperOptions.autoplay || false,
          breakpoints: {
            750: {
              slidesPerView: 2.2,
              spaceBetween: swiperOptions.spaceBetweenDesktop || 16
            },
            990: {
              slidesPerView: 3.2
            }
          },
          on: {
            autoplayTimeLeft(_s, time, progress) {
              progressCircle?.style.setProperty("--progress", 1 - progress);
              if (progressContent) progressContent.textContent = `${Math.ceil(time / 1000)}s`;
            }
          }
        };
      }

      if (!sliderOptions.effect && this.classList.contains("js-testimonials")) {
        sliderOptions.effect = "slide";
      }

      this.slider = new Swiper(this, sliderOptions);

      if (prevButton && prevButton instanceof HTMLElement) {
        prevButton.onclick = (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (!this.slider) return;
          if (this.slider.isBeginning) {
            const slideCount = this.slider.slides ? this.slider.slides.length : 1;
            this.slider.slideTo(slideCount - 1);
          } else {
            this.slider.slidePrev();
          }
        };
      }

      if (nextButton && nextButton instanceof HTMLElement) {
        nextButton.onclick = (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (!this.slider) return;
          if (this.slider.isEnd) {
            this.slider.slideTo(0);
          } else {
            this.slider.slideNext();
          }
        };
      }

      // Custom thumbnail animation logic for testimonials
      if (this.classList.contains("js-testimonials")) {
        const mediaContainer = this.closest(".section-testimonials")?.querySelector(".testimonials__media") || document.querySelector(".testimonials__media");
        if (mediaContainer) {
          const images = mediaContainer.querySelectorAll("img");

          images.forEach((img, i) => {
            img.style.opacity = i === 0 ? "1" : "0";
            img.style.display = i === 0 ? "block" : "none";
          });

          this.slider.on("slideChangeTransitionStart", () => {
            const activeIndex = this.slider.realIndex;

            images.forEach((img, i) => {
              if (i === activeIndex) {
                img.style.display = "block"; // Show active image before transition
                requestAnimationFrame(() => {
                  img.style.opacity = "1";
                });
              } else {
                img.style.opacity = "0";
              }
            });
          });

          this.slider.on("slideChangeTransitionEnd", () => {
            const activeIndex = this.slider.realIndex;
            images.forEach((img, i) => {
              if (i !== activeIndex) {
                img.style.display = "none"; // Hide after fade out completes
              }
            });
          });
        }
      }
    }
  }

  customElements.define("card-slider", CardSlider);
}